// removed by extract-text-webpack-plugin
module.exports = {"sso-login-seperator":"sso-login-seperator","ssoLoginSeperator":"sso-login-seperator","mac-auto-redirect":"mac-auto-redirect","macAutoRedirect":"mac-auto-redirect"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account/externalSsoLogins/style.scss
// module id = 601
// module chunks = 0